import { Values } from './context';
import { SEARCH_TYPE_NAMES } from './constants';
import { SearchType } from './types';

type Errors = Record<keyof Values, string>;

export const validate = (
  { destination, datepicker, departure }: Values,
  searchType: SearchType
) => {
  const errors = {} as Errors;

  if (!destination) {
    errors.destination = 'Required';
  }
  if (!datepicker && destination && searchType !== SEARCH_TYPE_NAMES.TRIP) {
    errors.datepicker = 'Required';
  }
  if (
    /* search for one hotel with vacationOptions denied */
    destination?.groupName === 'hotels' &&
    (datepicker?.nights || datepicker?.nightsPreset || datepicker?.startDatePreset)
  ) {
    errors.datepicker = 'Required';
  }
  if (!departure && destination && datepicker && searchType === SEARCH_TYPE_NAMES.PACKAGE) {
    errors.departure = 'Required';
  }
  return errors;
};
